<template>
	<ul>
		<li v-if="competence.Icon" class="icon-cell"><img :src="baseUrl + competence.Icon.url" class="competence-icon"/></li>		
		<li class="headline-cell light-text feature-headline">{{competence.headline}}</li>
		<li class="subtext-cell light-text content-description">{{competence.descShort}}</li>
		<li class="description-cell content-description light-text">{{competence.descLong}}</li>
	</ul>
</template>

<script>
	export default {
		Name: 'CompetencesCell',
			props: {
				competence: {type:Object},
				baseUrl: String,
		}
	}
</script>

<style>

	.subtext-cell{
		min-height: 4em;
		border-bottom: 3px solid #aa1c48;
		margin-bottom: 20px;
	}

	@media (max-width: 991px) {
		.headline-cell{
			min-height: 0;
		}

		.subtext-cell{
			min-height: 0;
		}
	}

</style>

<style scoped>

	li {
		margin-left: auto;
		margin-right: auto;
		list-style-type: none;
		max-width: 80%;
		min-height: auto;
		padding-bottom: 10px;
	}

	.headline-cell{
		padding-bottom: 25px;
	}

	ul {
		display: inline;
		text-align: center;
	}

	.competence-icon {
		max-width: 150px;
		max-height: 150px;
	}

	.competences-headline {
		font-size: 26px;	
	}
	
	.description-cell {
		font-size: 15px;
		line-height:21px;
	}

	@media (min-width: 991px) {
		.content-subtext {
			font-size: 2em;
		}
	}

	@media (max-width: 991px) {
		.competences-headline {
			font-size: 22px;	
		}
		.competence-icon {
			max-width: 130px;
			max-height: 130px;
		}
}

	@media (max-width: 767px) {
		.competences-headline {
			font-size: 18px;	
		}

		.feature-headline {
			margin: 0;	
		}

		.competence-icon {
			max-width: 100px;
			max-height: 100px;
		}

		li {
			max-width: 100%;
			text-align: left;
			margin-right: 20%;
		}
		
		ul {
			padding: 0;
		}
}

	@media (max-width: 575px) {
		li {
			margin-right: 0;
		}
	}

</style>


